import Keycloak, {
  KeycloakInitOptions,
  KeycloakResourceAccess,
} from "keycloak-js";
import { AuthEntity } from "@core/services/AuthEntity.tsx";
import { TIME_TOKEN_TO_UPDATE_BEFORE_EXPIRED } from "@utils/constant.ts";
import { APPkeycloakConfig, apiURL } from "@utils/environment.ts";

const keycloak = new Keycloak({
  url: APPkeycloakConfig.url,
  realm: APPkeycloakConfig.realm,
  clientId: APPkeycloakConfig.clientID,
});

let initialized = false;
let isOpened = false;
let onUpdatingToken = false;

export const initKeycloak = async (): Promise<boolean> => {
  if (initialized) {
    console.warn("Keycloak is already initialized!");
    return true;
  }

  try {
    let token = localStorage.getItem("token");
    let configInit: KeycloakInitOptions = {
      onLoad: "login-required",
      checkLoginIframe: false,
      checkLoginIframeInterval: 15,
    };
    if (!APPkeycloakConfig.pkce) configInit.pkceMethod = false;
    if (token) configInit.token = token;
    const authenticated = await keycloak.init(configInit);
    initialized = true;
    return authenticated;
  } catch (error) {
    console.error("Keycloak initialization failed", error);
    return false;
  }
};

setInterval(() => {
  updateToken();
}, TIME_TOKEN_TO_UPDATE_BEFORE_EXPIRED * 1000);


export const loginKeycloak = async () => {
  try {
    if (!keycloak.authenticated) {
      await keycloak.login({
        redirectUri: window.location.origin, 
      });
    }
  } catch (error) {
    console.error("Keycloak login failed", error);
  }
};

/** Clés liées à l'authentification — à supprimer à la déconnexion.
 *  Ne PAS utiliser localStorage.clear() afin de préserver les données
 *  applicatives persistantes (dynamicOptionsCount, complaintCustomOptions…). */
const AUTH_STORAGE_KEYS = ["token", "refreshToken"];

export const logoutKeycloak = async () => {
  try {
    // Logger la déconnexion avant de supprimer le token
    const auditUserRaw = localStorage.getItem("audit_user");
    const token = keycloak.token;
    if (auditUserRaw && token) {
      try {
        const auditUser = JSON.parse(auditUserRaw);
        await fetch(`${apiURL}/audit-log`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            action: "LOGOUT",
            userId: auditUser.userId,
            username: auditUser.username,
            role: auditUser.role,
            targetType: "SESSION",
            targetId: auditUser.userId,
            details: "Déconnexion",
          }),
        });
      } catch { /* ne pas bloquer la déconnexion si le log échoue */ }
    }
    if (token) {
      try {
        await fetch(`${apiURL}/auth/logout`, {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
        });
      } catch { /* best-effort : ne pas bloquer la déconnexion si la révocation échoue */ }
    }

    AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
    localStorage.removeItem("audit_user");
    sessionStorage.removeItem("_audit_logged");
    console.log("[Keycloak] logout — clés auth supprimées, données app conservées");
    await keycloak.logout({
      redirectUri: window.location.origin,
    });
  } catch (error) {
    console.error("Keycloak logout failed", error);
  }
};

export const getTokenKeycloak = async (): Promise<string | null> => {
  try {
    if (!keycloak.authenticated) {
      console.warn("User is not authenticated, no token available.");
      return null;
    }

    if (!keycloak.token) {
      let tokenLocalStorage = localStorage.getItem("token");

      if (!tokenLocalStorage || tokenLocalStorage === null) {
        await updateToken();

        tokenLocalStorage = localStorage.getItem("token");

        if (!tokenLocalStorage || tokenLocalStorage === null) {
          return "";
        }
      }

      return tokenLocalStorage;
    }

    return keycloak.token ?? null;
  } catch (error) {
    console.error("Failed to get Keycloak token", error);
    return null;
  }
};

// export const updateToken = async () => {
//   if (onUpdatingToken) return;

//   onUpdatingToken = true;  
//   try {
//     if (keycloak.isTokenExpired(TIME_TOKEN_TO_UPDATE_BEFORE_EXPIRED)) {
//       handleSessionExpired();
//       return;
//     }

//     const refreshed = await keycloak.updateToken(TIME_TOKEN_TO_UPDATE_BEFORE_EXPIRED);
//     if (refreshed) {
//       console.log("Token refreshed");
//       localStorage.setItem("token", JSON.stringify(keycloak.token));
//       AuthEntity.setToken(keycloak.token + "");
//     } else {
//       console.warn("Token not refreshed");
//     }
//   } catch (error) {
//     console.error("Erreur lors de la mise à jour du token :", error);
//     handleSessionExpired();
//   } finally {
//     onUpdatingToken = false;
//   }
// };

// Fonction pour gérer une session expirée
// const handleSessionExpired = () => {
//   alert("Votre session a expiré. Veuillez vous reconnecter pour continuer.");
//   logoutKeycloak();
// };


// export const updateToken = async () => {
//   if (onUpdatingToken) {
//     return;
//   }

//   onUpdatingToken = true;

//   try {
//     if (keycloak.isTokenExpired()) {
//       if (!isOpened) {
//         isOpened = true;
//         alert(
//           "Votre session a expiré. Veuillez vous reconnecter pour continuer."
//         );
//       }
//       logoutKeycloak();
//       return;
//     }

//     if (keycloak.token) {
//       localStorage.setItem("token", JSON.stringify(keycloak.token));
//       AuthEntity.setToken(keycloak.token + "");
//     }

//     if (!keycloak.authenticated) {
//       // Si l'utilisateur n'est pas authentifié, logout et alerte
//       if (!isOpened) {
//         isOpened = true;
//         alert(
//           "Votre session a expiré. Veuillez vous reconnecter pour continuer."
//         );
//       }
//       logoutKeycloak();
//       return;
//     }

//     // Essayez de mettre à jour le token si nécessaire
//     const refreshed = await keycloak.updateToken(
//       TIME_TOKEN_TO_UPDATE_BEFORE_EXPIRED
//     );
//     if (refreshed) {
//       console.log("Token refreshed");
//       localStorage.setItem("token", JSON.stringify(keycloak.token));
//       AuthEntity.setToken(keycloak.token + "");
//     } else {
//       console.log("Token not refreshed");
//     }
//   } catch (error) {
//     console.error("Erreur lors de la mise à jour du token", error);
//     if (!isOpened) {
//       isOpened = true;
//       alert(
//         "Votre session a expiré. Veuillez vous reconnecter pour continuer."
//       );
//     }
//     logoutKeycloak();
//   } finally {
//     onUpdatingToken = false;
//   }
// };

export const updateToken = async () => {
  if (onUpdatingToken) {
    return;
  }

  onUpdatingToken = true;

  try {
    if (keycloak.isTokenExpired(TIME_TOKEN_TO_UPDATE_BEFORE_EXPIRED)) {
      const refreshed = await keycloak.updateToken(TIME_TOKEN_TO_UPDATE_BEFORE_EXPIRED);
      
      if (refreshed) {

        if (keycloak.token) {
          localStorage.setItem("token", JSON.stringify(keycloak.token));
          localStorage.setItem("refreshToken", keycloak.refreshToken ?? "");
          AuthEntity.setToken(keycloak.token);
        }
      } else {
        console.log("Le token n'a pas pu être rafraîchi.");
        logoutKeycloak();
        return;
      }
    }

    if (!keycloak.authenticated) {
      if (!isOpened) {
        isOpened = true;
        alert("Votre session a expiré. Veuillez vous reconnecter pour continuer.");
      }
      logoutKeycloak();
      return;
    }
  } catch (error) {
    console.error("Erreur lors de la mise à jour du token", error);
    if (!isOpened) {
      isOpened = true;
      alert("Votre session a expiré. Veuillez vous reconnecter pour continuer.");
    }
    logoutKeycloak();
  } finally {
    onUpdatingToken = false;
  }
};


export const getProfilKeyCloak =
  async (): Promise<Keycloak.KeycloakProfile> => {
    try {
      if (!keycloak.authenticated) {
        throw new Error("Utilisateur non authentifié");
      }

      const userProfile = await keycloak.loadUserProfile();
      return userProfile;
    } catch (error) {
      console.error(
        "Erreur lors de la récupération du profil utilisateur :",
        error
      );
      throw error;
    }
  };

export const getResourceAccess = async (): Promise<
  KeycloakResourceAccess | undefined
> => {
  return keycloak.resourceAccess;
};

export const getUserInfoKeyCloak =
  async (): Promise<Keycloak.KeycloakProfile> => {
    return keycloak.loadUserInfo();
  };
